import React, { useState, useEffect } from 'react';
import ListSubheader from '@mui/material/ListSubheader';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Radio from '@mui/material/Radio';
import ManufacturersPopOver from './ManufacturersPopOver'
import CategoryPopOver from './CategoryPopOver'
import { Popover } from 'reactstrap';
import './index.css';
import { connect } from 'react-redux';
import { getSearchProduct } from 'actions/buyer';
import { campaignsVisible } from 'util/campaignVisibility';
import { Helmet } from "react-helmet";

// The reward buckets a buyer can narrow to - PRODUCT LEVEL only. `all` is every product-level coupon
// or gift, `coupon` product-level money off an item, `gift` a product-level free gift. Seller cashback
// / seller store-wide gifts and Medimny's platform tier are not here: they auto-apply at checkout on
// qualifying orders, so filtering on them would tell the buyer nothing useful.
const OFFER_FILTERS = [
  { value: 'all', label: 'ALL OFFERS' },
  { value: 'coupon', label: 'COUPONS' },
  { value: 'gift', label: 'GIFTS' }
]

const PinnedSubheaderList = (props) => {
  const navigate = useNavigate()
  const location = useLocation()
  const params = useParams()
  const [checked, setChecked] = useState([0])
  const [obj, setObj] = useState({})
  const [popoverOpenCompanies, setPopoverOpenCompanies] = useState(false)
  const [popoverOpenCategories, setPopoverOpenCategories] = useState(false)
  const [categories, setCategories] = useState([])
  const [selectCat, setSelectCat] = useState('')

  function toggleCompaniesPopOver() {
    setPopoverOpenCompanies(!popoverOpenCompanies);
  }

  function toggleCategoryPopOver() {
    setPopoverOpenCategories(!popoverOpenCategories);
  }

  const handleToggle = (value) => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];
    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setChecked(newChecked);
  };

  const handleClick = (key, e) => {
    // `offer` may legitimately be cleared back to '' (the "All Products" option on a category
    // page), so it is exempt from the non-empty guard the other radios rely on.
    if (e !== '' || key === 'offer') {
      const decodedURL = JSON.parse('{"' + decodeURIComponent(params.search.replace(/&/g, "\",\"").replace(/=/g, "\":\"").replace(/%(?![0-9][0-9a-fA-F]+)/g, '%25')) + '"}')
      let newObj = { ...obj }
      newObj.search = decodedURL.search ? decodedURL.search : ''
      newObj.sortBy = decodedURL.sortBy ? decodedURL.sortBy : 'price'
      newObj.category_id = decodedURL.category_id ? decodedURL.category_id.split(',') : []
      newObj.medicineType = decodedURL.medicineType ? decodedURL.medicineType : ''
      newObj.offer = decodedURL.offer ? decodedURL.offer : ''
      newObj[key] = e;
      let url = Object.keys(newObj).map(k => `${encodeURIComponent(k)}=${encodeURIComponent(newObj[k])}`).join('&');
      setObj(newObj)
      let catName = selectCat ? ((selectCat).replace(/ /g, '-')).replace(/[\/,  @#%\^;?]/g, ' ').toLowerCase() : 'category'
      navigate({ pathname: `/search-results/${catName && catName !== '' ? catName : 'category'}/${url}`, state: 'searchPage' })
      const data = {
        key: newObj.search ? newObj.search : '',
        company_id: newObj.company_id ? newObj.company_id : '',
        category_id: newObj.category_id ? newObj.category_id : '',
        seller_id: newObj.seller_id ? newObj.seller_id : '',
        mediType: newObj.medicineType ? newObj.medicineType : '',
        discount: newObj.discount && newObj.discount === '10 or more' ? 10 : newObj.discount === '20 or more' ? 20 : newObj.discount === '50 or more' ? 50 : '',
        offer: newObj.offer ? newObj.offer : '',
        page: 1,
        perPage: 12,
        sortBy: newObj.sortBy
      }
      props.getSearchProduct({ data })
    }
  }

  const setInitData = async () => {
    const decodedURL = JSON.parse('{"' + decodeURIComponent(params.search.replace(/&/g, "\",\"").replace(/=/g, "\":\"").replace(/%(?![0-9][0-9a-fA-F]+)/g, '%25')) + '"}')
    let { filterFromParent } = props;
    let cateogoryData = await filterFromParent && filterFromParent.detail && filterFromParent.detail.categories.filter((e) => e._id === decodedURL.category_id);
    let catData = cateogoryData && cateogoryData.length > 0 ? cateogoryData[0].name : ''
    await setSelectCat(catData)
    let newObj = { ...obj }
    newObj.search = decodedURL.search ? decodedURL.search : ''
    newObj.company_id = decodedURL.company_id ? decodedURL.company_id : ''
    newObj.category_id = decodedURL.category_id ? decodedURL.category_id.split(',') : ''
    newObj.seller_id = decodedURL.seller_id ? decodedURL.seller_id : ''
    newObj.sortBy = decodedURL.sortBy ? decodedURL.sortBy : 'price'
    newObj.medicineType = decodedURL.medicineType ? decodedURL.medicineType : ''
    newObj.discount = decodedURL.discount ? decodedURL.discount : ''
    newObj.offer = decodedURL.offer ? decodedURL.offer : ''
    setObj(newObj)
    setCategories(decodedURL.category_id ? decodedURL.category_id.split(',') : [])
  }

  useEffect(() => {
    setInitData()
  }, [])

  const reset = () => {
    const decodedURL = JSON.parse('{"' + decodeURIComponent(params.search.replace(/&/g, "\",\"").replace(/=/g, "\":\"").replace(/%(?![0-9][0-9a-fA-F]+)/g, '%25')) + '"}')
    // The offer is an opt-in narrowing on every page except the dedicated Coupons & Gifts scope
    // (whose URL is /coupons-and-gifts and whose identity IS the offer). Clearing filters removes the
    // offer everywhere else (back to "All Products"); on the Coupons & Gifts scope it resets to "All
    // Offers" instead of dropping the buyer into the whole catalogue. medicineType (the category the
    // buyer is on) is always preserved.
    const isCouponsScope = location.pathname.includes('coupons-and-gifts')
    let offer = isCouponsScope ? (decodedURL.offer ? 'all' : '') : ''
    let newObj = { search: decodedURL.search ? decodedURL.search : '', sortBy: decodedURL.sortBy, medicineType: decodedURL.medicineType ? decodedURL.medicineType : '', offer }
    let url = Object.keys(newObj).map(k => `${encodeURIComponent(k)}=${encodeURIComponent(newObj[k])}`).join('&');
    navigate({ pathname: `/search-results/category/${url}`, state: 'searchPage' })
    const data = {
      key: decodedURL.search ? decodedURL.search : '',
      company_id: '',
      category_id: '',
      seller_id: '',
      page: 1,
      perPage: 12,
      sortBy: decodedURL.sortBy ? decodedURL.sortBy : 'price',
      mediType: decodedURL.medicineType ? decodedURL.medicineType : '',
      offer
    }
    props.getSearchProduct({ data })
    setChecked([0])
    setCategories([])
    setObj({ search: decodedURL.search, company_id: '', category_id: '', seller_id: '', medicineType: decodedURL.medicineType ? decodedURL.medicineType : '', discount: '', offer })
  }

  const handleCategories = async (key, e) => {
    const decodedURL = JSON.parse('{"' + decodeURIComponent(params.search.replace(/&/g, "\",\"").replace(/=/g, "\":\"").replace(/%(?![0-9][0-9a-fA-F]+)/g, '%25')) + '"}')
    let newObj = { ...obj }
    newObj.search = decodedURL.search ? decodedURL.search : ''
    newObj[key] = e;
    newObj.sortBy = decodedURL.sortBy ? decodedURL.sortBy : 'price'
    newObj.medicineType = decodedURL.medicineType ? decodedURL.medicineType : ''
    newObj.discount = decodedURL.discount ? decodedURL.discount : ''
    newObj.offer = decodedURL.offer ? decodedURL.offer : ''
    let temp = [...categories]
    if (e.target.checked) {
      temp.push(e.target.value)
      setCategories(temp)
    } else {
      temp.splice(getChecked(e.target.value), 1)
      setCategories(temp)
    }
    let { filterFromParent } = props;
    let cateogoryData = await filterFromParent && filterFromParent.detail && filterFromParent.detail.categories.filter((e) => e._id === categories[0]);
    await setSelectCat(cateogoryData && cateogoryData.length > 0 ? cateogoryData[0].name : '')
    const data = {
      key: newObj.search ? newObj.search : '',
      company_id: newObj.company_id ? newObj.company_id : '',
      category_id: temp,
      seller_id: newObj.seller_id ? newObj.seller_id : '',
      mediType: newObj.medicineType ? newObj.medicineType : '',
      discount: newObj.discount && newObj.discount === '10 or more' ? 10 : newObj.discount === '20 or more' ? 20 : newObj.discount === '50 or more' ? 50 : '',
      offer: newObj.offer ? newObj.offer : '',
      page: 1,
      perPage: 12,
      sortBy: newObj.sortBy
    }
    if (decodedURL.search) {
      newObj.search = decodedURL.search
    }
    newObj.category_id = temp.length > 0 ? temp.toString() : ''
    let url = Object.keys(newObj).map(k => `${encodeURIComponent(k)}=${encodeURIComponent(newObj[k])}`).join('&');
    setObj(newObj)
    let catName = selectCat && ((selectCat).replace(/ /g, '-')).replace(/[\/,  @#%\^;?]/g, ' ').toLowerCase()
    navigate({ pathname: `/search-results/${catName && catName !== '' ? catName : 'category'}/${url}`, state: 'searchPage' })
    props.getSearchProduct({ data })
  }

  const getChecked = (data) => {
    let index = categories.findIndex((val) => val === data)
    return index
  }

  const { filterFromParent } = props;

  // The offer filter shows on EVERY search page now: the dedicated Coupons & Gifts scope, each
  // category (Cool Chain, Ethical Branded, ...), Show All Deals, and keyword search. On the dedicated
  // Coupons & Gifts scope (its URL is /coupons-and-gifts) the page IS the offer, so the buckets are
  // ALL OFFERS / COUPONS / GIFTS. Everywhere else the offer is an opt-in narrowing, so it leads
  // with "All Products" (offer '') as the default.
  //
  // Registered buyers only, in step with the rest of the campaign layer: a guest sees no coupon or
  // gift on the cards, so a bucket to narrow to them would filter on something invisible (see
  // util/campaignVisibility).
  const isCouponsScope = location.pathname.includes('coupons-and-gifts')
  const showOfferFilter = campaignsVisible()
  const offerOptions = isCouponsScope
    ? OFFER_FILTERS
    : [{ value: '', label: 'ALL PRODUCTS' }, ...OFFER_FILTERS]

  return (
    <List className="" subheader={<div />}>
      {selectCat !== 'category' ? <Helmet>
        <title>Buy {selectCat} Medication Online In India - Medimny</title>
        <meta name="title" content={`Buy ${selectCat} Medication Online In India - Medimny`} />
        <meta name="description" content={`Medimny is a B2B E-Commerce platform for Pharmaceutical Products for Distributors, Stockists and Retail Drug Stores serving entire nation. Buy ${selectCat} Medication Online In India.`} />
      </Helmet> : ''
      }
      <button className="mt-3  mb-3 ml-2"
        style={{
          backgroundColor: "white",
          color: '#f3554c', borderRadius: '5px', border: 'none'
        }} onClick={reset} >
        Clear Filters
      </button>

      {/* //------------------------------------------- COUPONS & GIFTS ---------------------------------------------------// */}
      {/* Shown on the Coupons & Gifts scope and on every category page. On a category the buyer can
          narrow to listings carrying a coupon, seller cashback or free gift, or leave it on
          "All Products". If a bucket is empty the results pane shows why ("No coupons running..."). */}
      {showOfferFilter ?
        <React.Fragment>
          <ListSubheader className="text-muted bg-grey lighten-4">{'Coupons & Gifts'}</ListSubheader>
          {offerOptions.map((option) => (
            <ListItem className="listItemName" button key={option.value || 'none'} onClick={event => handleToggle(option.value)} style={{ paddingTop: "0px", paddingBottom: "0px" }}>
              <Radio color="primary"
                checked={(obj.offer || '') === option.value}
                onClick={(e) => {
                  handleClick('offer', option.value);
                }}
                value="a" name="radio button demo"
                aria-label="A" />
              <ListItemText className="" primary={option.label} />
            </ListItem>
          ))}
        </React.Fragment>
        : null
      }

      {/* //------------------------------------------- DISCOUNT ------------------------------------------------------------// */}

      <ListSubheader className="text-muted bg-grey lighten-4">{'Discount'}</ListSubheader>
      <ListItem className="listItemName" button key={'10 or more'} onClick={event => handleToggle('10 or more')} style={{ paddingTop: "0px", paddingBottom: "0px" }}>
        <Radio color="primary"
          checked={obj.discount === '10 or more'}
          onClick={(e) => {
            handleClick('discount', '10 or more');
          }}
          value="a" name="radio button demo"
          aria-label="A" />
        <ListItemText className="" primary={"10% OFF OR MORE"} />
      </ListItem>
      <ListItem className="listItemName" button key={'20 or more'} onClick={event => handleToggle('20 or more')} style={{ paddingTop: "0px", paddingBottom: "0px" }}>
        <Radio color="primary"
          checked={obj.discount === '20 or more'}
          onClick={(e) => {
            handleClick('discount', '20 or more');
          }}
          value="a" name="radio button demo"
          aria-label="A" />
        <ListItemText className="" primary={"20% OFF OR MORE"} />
      </ListItem>
      <ListItem className="listItemName" button key={'50 or more'} onClick={event => handleToggle('50 or more')} style={{ paddingTop: "0px", paddingBottom: "0px" }}>
        <Radio color="primary"
          checked={obj.discount === '50 or more'}
          onClick={(e) => {
            handleClick('discount', '50 or more');
          }}
          value="a" name="radio button demo"
          aria-label="A" />
        <ListItemText className="listItemName" primary={"50% OFF OR MORE"} />
      </ListItem>

      {/* //------------------------------------------- CATEGORY ------------------------------------------------------------// */}

      <ListSubheader className="text-muted bg-grey lighten-4">Categories</ListSubheader>
      {filterFromParent && filterFromParent.detail && filterFromParent.detail.categories.slice(0, 5).map((listItem) => (
        <div key={listItem._id}>
          <ListItem className="listItemName" button key={listItem._id} onClick={event => handleToggle(listItem._id)} style={{ paddingTop: "0px", paddingBottom: "0px" }}>
            <Checkbox
              onClick={(e) => {
                handleCategories('category_id', e);
              }}
              value={listItem._id}
              color="primary"
              checked={getChecked(listItem._id) > -1 ? true : false}
              tabIndex="-1"
            />
            <ListItemText className="" primary={listItem.name} />
          </ListItem>
        </div>
      ))}
      <div className="ml-4 mb-3">
        <button className="moreButton" id="Categories" onClick={toggleCategoryPopOver}>
          More
        </button>
        <Popover trigger="legacy" className="manufacturersPopOver" placement="right" isOpen={popoverOpenCategories} target="Categories" toggle={toggleCategoryPopOver}>
          <i class="zmdi zmdi-close zmdi-hc-2x" style={{ float: "right", cursor: "pointer", zIndex: 1, }} onClick={toggleCategoryPopOver}></i>
          <CategoryPopOver
            handleCategories={handleCategories}
            getChecked={getChecked}
            category_id={obj.category_id}
            showAddToCard={!location.pathname.includes('/view-company')}
            dataFromParent={filterFromParent && filterFromParent.detail && filterFromParent.detail.categories ? filterFromParent.detail.categories : []}
          />
        </Popover>
      </div>

      {/* //------------------------------------------- COMAPNY ------------------------------------------------------------// */}

      <ListSubheader className="text-muted bg-grey lighten-4">Companies</ListSubheader>
      {filterFromParent && filterFromParent.detail && filterFromParent.detail.comapnies.slice(0, 5).map((listItem) =>
      (<div key={listItem._id}>
        <ListItem className="listItemName" button key={listItem._id} onClick={event => handleToggle(listItem._id)} style={{ paddingTop: "0px", paddingBottom: "0px", fontSize: "10px" }}>
          <Radio color="primary"
            checked={obj.company_id === listItem._id}
            onClick={(e) => {
              handleClick('company_id', listItem._id);
            }}
            value="a" name="radio button demo"
            aria-label="A"
          />
          <ListItemText primary={listItem.name} />
        </ListItem>
      </div>
      ))}

      <div className="ml-4 mb-3">
        <button className="moreButton" id="Companies" onClick={toggleCompaniesPopOver}>
          More
        </button>
        <Popover trigger="legacy" className="manufacturersPopOver" placement="right" isOpen={popoverOpenCompanies} target="Companies" toggle={toggleCompaniesPopOver}>
          <i class="zmdi zmdi-close zmdi-hc-2x" style={{ float: "right", cursor: "pointer", zIndex: 1, }} onClick={toggleCompaniesPopOver}></i>
          <ManufacturersPopOver
            handleClick={handleClick}
            company_id={obj.company_id}
            showAddToCard={!location.pathname.includes('/view-company')}
            dataFromParent={filterFromParent && filterFromParent.detail && filterFromParent.detail.comapnies ? filterFromParent.detail.comapnies : []}
          />
        </Popover>
      </div>
    </List>
  );
}


const mapStateToProps = ({ buyer }) => {
  const { searchProduct } = buyer;
  return { searchProduct }
};

export default connect(mapStateToProps, { getSearchProduct })(PinnedSubheaderList);